"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toColumnDefs = exports.getColumnVisibility = exports.calculateTotals = exports.accessKeyToId = void 0;
var _react = require("react");
var toColumnDefs = function toColumnDefs(children, intl) {
  var grouping = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var columnStateAccessor = arguments.length > 3 ? arguments[3] : undefined;
  var resolvedChildren = "type" in children && children.type === _react.Fragment ? children.props.children : children;
  var columnDefs = [];
  _react.Children.forEach(resolvedChildren, function (child) {
    if (child !== null && child !== void 0 && child.type) {
      if ("toColumnDef" in child.type) {
        columnDefs.push(child.type.toColumnDef(child, intl, columnStateAccessor));
      } else if ("toColumnDefs" in child.type) {
        columnDefs.push.apply(columnDefs, _toConsumableArray(child.type.toColumnDefs(child, intl, grouping)));
      } else {
        console.error("Invalid Column element: ", child);
      }
    }
  });
  return columnDefs;
};
exports.toColumnDefs = toColumnDefs;
var accessKeyToId = function accessKeyToId(key) {
  return typeof key === "string" ? key.replace(new RegExp('\\.', 'g'), "_") : String(key);
};
exports.accessKeyToId = accessKeyToId;
var getColumnVisibility = function getColumnVisibility(columnDefs) {
  var grouping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hasGroupingColumn = columnDefs.some(function (columnDef) {
    return columnDef.id === 'grouping-column';
  });
  var isHandledByGroupingColumn = function isHandledByGroupingColumn(columnDef) {
    return hasGroupingColumn && ('accessorKey' in columnDef && grouping.includes(String(columnDef.accessorKey)) || columnDef.id && grouping.includes(columnDef.id));
  };
  return columnDefs.filter(function (columnDef) {
    var _columnDef$meta;
    return ((_columnDef$meta = columnDef.meta) === null || _columnDef$meta === void 0 ? void 0 : _columnDef$meta.visible) === false || isHandledByGroupingColumn(columnDef);
  }).reduce(function (columnVisibility, columnDef) {
    if (columnDef.id) {
      columnVisibility[columnDef.id] = false;
    } else if ('accessorKey' in columnDef) {
      columnVisibility[accessKeyToId(columnDef.accessorKey)] = false;
    }
    return columnVisibility;
  }, {});
};
exports.getColumnVisibility = getColumnVisibility;
var calculateTotals = function calculateTotals(showFooter, data) {
  if (showFooter) {
    var totals = data.reduce(function (accumulator, currentValue) {
      Object.entries(currentValue).forEach(function (entry) {
        var _entry = _slicedToArray(entry, 2),
          key = _entry[0],
          value = _entry[1];
        if (typeof value === "number") {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
          } else {
            accumulator[key] += value;
          }
        }
      });
      return accumulator;
    }, {});
    totals.getValue = function (column) {
      return totals[column];
    };
    return totals;
  }
  return undefined;
};
exports.calculateTotals = calculateTotals;